export default {
	'userCancel': 'إلغاء المستخدم',
	'addrLp': 'ليرة لبنانية عنوان العقد',
	'bscInLbb': 'بكالوريوس في lbbcoin',
	'goSwap': 'كسواب للتجارة',
	'sumLbb': 'التراكمي { 0 }',
	'lookLbb': 'عرض العقد',
	'addrLbb': 'OC عنوان العقد',
	'addrDead': 'عنوان الثقب الأسود',
	'addrMarket': 'عنوان التسويق',
	'ratioTotal': 'مجموع نقاط البيع : 10 ٪',
	'ratioLp': 'أ - معامل السيولة : 5 في المائة',
	'ratioDead': 'ب - معامل التدمير : 3 في المائة',
	'ratioInv': '( ج ) عامل الدعوة : 1 في المائة',
	'ratioMarket': 'د - معامل التسويق : 1 في المائة',
	'contractDesc': 'تنفيذ سلسلة كاملة من المنطق',
	'contract': 'عقد',
	'inviteTotal': 'شبكة كاملة دعوة مكافأة : { 0 }',
	'inviteMy': 'دعوتي مكافأة : { 0 }',
	'lpTotal': 'شبكة كاملة من السيولة مكافأة : { 0 }',
	'lpMy': 'بلدي مكافأة السيولة : { 0 }',
	'lpDesc': 'بلدي / كامل صافي السيولة : { 0 } / { 1 }',
	'lpAdd': 'إضافة سيولة',
	'lp': 'سيولة',
	'invSell': 'أعلى 1% دعوة مكافأة',
	'lpSell': 'عقد السيولة المرجحة مكافأة 5 ٪ من كل بيع',
	'myInvites': 'دعوتي',
	'effective': 'effective',
	'ineffective': 'ineffective',
	'myInviter': 'بلدي الإحالة',
	'invite': 'دعوة',
	'inviteNotice1': 'أرسل إلى الجانب الآخر 0.1 OC',
	'inviteNotice2': 'دعوة ناجحة بعد تأكيد',
	'inviteBind': 'يرجى ربط المراجع الخاصة بك',
	'chainConfirm': 'في سلسلة',
	'{0} Operate Fast': 'عملية { 0 } متكررة جدا ، يرجى مواصلة { 1 } ثانية في وقت لاحق',
	'English': 'English',
	'Chinese': '中文',
	'Conrim': 'تأكيد',
	'Osnft Detail': 'عرض التفاصيل',
	'{0} Not Enogugh': 'عدم كفاية { 0 }',
	'Operate Success': 'عملية ناجحة',
	'zlang143': 'نسخة ناجحة',
	'Cht': '繁體中文',
	'YueNan': 'Việt Nam',
	'YinNi': 'Bahasa Indonesia',
	'RiWen': ' にほんご',
	'HanWen': '한국어',
	'TaiWen': 'ไทย',
	'ALaBoWen': ' العربية ',
	'ocLockTitle': 'قفل OC',
	'ocLockDeposit': 'إيداع',
	'ocLockActive': 'Status',
	'ocLockReleased': 'تم الإصدار',
	'ocLockClaim': 'سحب',
	'themeNeon': 'ازرق نيون',
	'themeIce': 'دائرة جليدية',
	'themeViolet': 'بنفسجي ذهبي',
	'themeAurora': 'نعناع الشفق',
	'themeEmber': 'ليل الجمر',
	'themeMono': 'احادي داكن',
	'Refresh': 'Refresh',
	'No Records': 'No Records',
	'eventLogs': 'Event Logs',
	'eventCount': 'Records',
	'eventTotal': 'Amount Summary',
	'eventAll': 'All',
	'eventInviteFeature': 'Invite',
	'eventRewardFeature': 'Rewards',
	'eventBonusFeature': 'Mining',
	'eventLockFeature': 'Lock',
	'eventLock': 'Lock',
	'eventRelease': 'Release',
	'eventClaim': 'Claim',
	'eventBonus': 'Bonus',
	'eventInvite': 'Invite',
	'eventTransfer': 'Transfer',
	'eventOcLocked': 'OC Locked',
	'eventOcStaticRelease': 'Static Release',
	'eventOcDynamicRelease': 'Dynamic Release',
	'eventOcClaimed': 'Lock Claim',
	'eventBonusTriggered': 'Bonus Distributed',
	'eventBonusReceived': 'Bonus Received',
	'eventInviteRequested': 'Invite Requested',
	'eventDirectReward': 'Direct Reward',
	'eventLiquidityReward': 'Liquidity Reward',
	'eventSlowQueryProgress': 'Query is slow, checked block {0}/{1}',
	'eventTenLevelBonus': 'Ten-Level Mining',
	'eventTenLevelBonusReceived': 'Ten-Level Mining Received',
	'eventReferralConfirmed': 'Referral Confirmed',
	'eventEffectiveInvite': 'Effective Invite',
	'eventEffectiveLp': 'Effective Account',
	'eventTransferIn': 'Transfer In',
}
